import PropTypes from 'prop-types';
import React, { Component } from 'react';
import * as constants  from '../../constants';
import i18next from "../../i18n";
import { ListOfAlfresco } from '../listsOfAlfresco/ListOfAlfresco';
import * as ModalDialog from '../ModalDialog';
import * as ListOfSignatories from '../listsOfAlfresco/ListOfSignatories';
import * as OrderedListOfSignatories from '../listsOfAlfresco/OrderedListOfSignatories';
export class AddSignatoryForm extends Component {
    static propTypes = {
        handleAddSignatory: PropTypes.func.isRequired
    };
    constructor(props) {
        super(props);
        this.state = {
            identifiers: [],
            usersEmails: []
        }
        this.actionHandlerCallback = this.actionHandlerCallback.bind(this);
        this.orderChangedHandler = this.orderChangedHandler.bind(this);
        this.showChoseDialog = this.showChoseDialog.bind(this);
    }
    componentDidMount() {
        this.showChoseDialog();
    }
    showChoseDialog() {
        let currentObject = this;
        ModalDialog.showModalDialog('loadingDialog', i18next.t("16"), "",
            <ListOfAlfresco actionHandlerCallback={this.actionHandlerCallback} actionsForAll={[{ title: i18next.t("add"), btnClass: "", type: constants.actionTypes.add, sortIndex: 0, isMultiaction: true }]}
                saveApi={`Table/Save?searchTableTypes=${constants.searchTableTypes.Users}`}
                parentComponent={ListOfSignatories} type={constants.searchTableTypes.Users}
                companyName={this.props.companyName} />, "feedPopup middle-size z-3", true, [],
            () => {
                if (currentObject.props.handleFormClose)
                    currentObject.props.handleFormClose();
            }
        );
    }
    async actionHandlerCallback(type, ids = [], emails = []) {
        const { identifiers, usersEmails } = this.state;
        // eslint-disable-next-line default-case
        switch (type) {
            case constants.actionTypes.save:
                if (identifiers.length > 0) {
                    this.props.handleAddSignatory(identifiers.map((item) => "workspace://SpacesStore/" + item).join(','));
                }
                return;
            case constants.actionTypes.add:
                this.setState({ identifiers: [...identifiers, ...ids], usersEmails: [...usersEmails, ...emails] });
                return ModalDialog.hideModalDialog('loadingDialog');
            case constants.actionTypes.remove:
                let updatedUsersEmails = usersEmails.filter((item) => emails.indexOf(item) === -1);
                this.setState({ identifiers: identifiers.filter((item) => ids.indexOf(item) === -1), usersEmails: updatedUsersEmails });
                if (updatedUsersEmails.length === 0) {
                    this.showChoseDialog()
                }
                break;
        }
    }
    orderChangedHandler(orderedValues) {
        this.setState({ identifiers: orderedValues });
    }
    render() {
        const { identifiers, usersEmails } = this.state;
        return (
            <>
                <div className="modal-body scrollYInner">
                    {usersEmails.length > 0 && <ListOfAlfresco
                        key={usersEmails.length}
                        companyName={this.props.companyName}
                        saveApi={`Table/Save?searchTableTypes=${constants.searchTableTypes.Users}`}
                        actionHandlerCallback={this.actionHandlerCallback}
                        parentComponent={OrderedListOfSignatories}
                        type={constants.searchTableTypes.Users}
                        actionsForAll={[{
                            title: i18next.t("remove"),
                            btnClass: "", type: constants.actionTypes.remove, sortIndex: 0, isMultiaction: true
                        }]}
                        additionalFilter={{ "UserName": usersEmails }}
                        orderBySettings={{ fieldName: "Id", orderedValues: identifiers }}
                        orderChangedHandler={this.orderChangedHandler} />}
                </div>
                <br/>
                <div className="modal-footer">
                    <div className="form-group form-group__last">
                        {identifiers.length > 0 ? <button type="button" className="btn btn-primary" onClick={() => this.actionHandlerCallback.bind(this)(constants.actionTypes.save)}>{i18next.t("sendToSignature")}</button> : ""}
                        <button type="button" className="btn btn-secondary" onClick={() => ModalDialog.showModalDialog('loadingDialog', i18next.t("16"), "", <ListOfAlfresco companyName={this.props.companyName} saveApi={`Table/Save?searchTableTypes=${constants.searchTableTypes.Users}`} actionHandlerCallback={this.actionHandlerCallback} actionsForAll={[{ title: i18next.t("add"), btnClass: "", type: constants.actionTypes.add, sortIndex: 0, isMultiaction: true }]} parentComponent={ListOfSignatories} type={constants.searchTableTypes.Users} />, "feedPopup middle-size z-3")}>{i18next.t("15")}</button>
                    </div>
                </div>
            </>
        );
    }
}